// start:ng42.barrel
export * from './rate-details.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/rate-details/index.ts